/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import React, { useContext, useEffect, useState } from 'react';
import styles from '../styles.module.scss';
import axiosInstance from '../../../../../../axios_instance';
import {
  AchievementListContext,
  IsAdminContext, NumberOfAchivementsContext, UserAchievementsDataContext
} from '../../../../../../context';
import { Row, Skeleton } from 'antd';
import { useParams } from 'react-router-dom';
import { reorder } from '../../../../../../utils/helper';
import swal from "sweetalert";
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import AchievementDetail from './achievement-detail-view';
import AddAchievement from './add-achievement';

//The parent component of core Achievement's card
const AchievementCard: React.FC<any> = (): JSX.Element => {
  const [userAchievementsData, setUserAchievementsData] = useState<any>([]);
  const { numberOfAchievements, setNumberOfAchievements } = useContext(NumberOfAchivementsContext);
  //state to store all Achievements from database
  const [AchievementList, setAchievementList] = useState<any>();
  //state to enable add new content.If its true,add form will appear.
  const [addNew, setAddNew] = useState<boolean>(false);
  //context to check whether the logged in user is admin or normal user.
  const isAdmin = useContext(IsAdminContext);
  //this query parameter in URL will be available if the user is admin
  const { employeeId } = useParams();
  const [message, setMessage] = useState<string>()
  const [isLoading, setIsLoading] = useState<boolean>(true);

  //retrieve all Achievements from database.User can select Achievement from available Achievements in this list.
  useEffect(() => {
    axiosInstance.get('/api/v1/profile/user-profiles/achievements').then((response) => {
      const allAchievements = response.data.achievements.filter(
        (achievement: any) => achievement['status']['id'] === 1
      );
      const achievements = allAchievements.reduce(
        (initialList: Object, CurrentList: { [key: string]: any }) => ({
          ...initialList,
          [CurrentList.achievement_name]: CurrentList.achievement_id,
        }),
        {}
      );
      setAchievementList(achievements);
    });
  }, []);

  //retrieve user's all Achievements information.
  useEffect(() => {
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/profile/admin/user-profiles/' + employeeId + '/achievements';
    } else {
      url = '/api/v1/profile/user-profiles/achievements';
    }
    axiosInstance.get(url).then((response) => {
      let userAchievements: Array<any> = [];
      if (response.data.achievements.length !== 0) {
        userAchievements = response.data.achievements.filter(
          (achievement: any) =>
            achievement['status']['id'] === 1
        );
        // const orderedAchievements = response.data.order_achievements.map((achievementId: number) =>
        //   userAchievements.find((userAchievement: any) => userAchievement.achievement_id === achievementId)
        // ).filter((item: any) => item !== undefined);
        setUserAchievementsData(userAchievements);
        // setUserAchievementData(userAchievements);
      } else {
        setUserAchievementsData(response.data.achievements);
      }
      setNumberOfAchievements(userAchievements.length);
    }).catch((error) => {
      console.log(error);
      setMessage("Something went wrong!Items couldn't be loaded!")
    }).finally(() => {
      setIsLoading(false)
    });
  }, []);

  const onDragEnd = (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    if (userAchievementsData.length < 2) {
      return;
    }
    if (result.source.index === result.destination.index) {
      return;
    }

    const items = reorder(
      userAchievementsData,
      result.source.index,
      result.destination.index
    );
    const order_list = items.map((item: any) =>
      item.achievement_id
    );
    setUserAchievementsData(
      items
    );

    const payload: any = {
      type: "achievements",
      updated_reorder_list: order_list
    };
    if (isAdmin === '1') {
      payload.profile_id = employeeId;
    }

    axiosInstance.post("/api/v1/reorder", payload).then((response) => {
      swal({
        title: 'Updated',
        text: 'Order of achievement has been updated',
        icon: "success",
      }).then((willRefresh) => {
        console.log()
      });
    }).catch((error) => {
      swal({
        title: 'Failed',
        text: 'Order of achievement could not be updated',
        icon: "error",
      }).then((willRefresh) => {
        console.log()
      });
    })

  }

  return (
    <div style={{ position: 'relative' }}>
      <UserAchievementsDataContext.Provider
        value={{ userAchievementsData, setUserAchievementsData }}
      >
        <AchievementListContext.Provider value={{ ...AchievementList }}>
          {isLoading ? <Skeleton active /> : <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided: any, snapshot: any) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {userAchievementsData && userAchievementsData.map((item: any, index: any) => (
                    <Draggable key={`row_${item.Achievement_id}`} draggableId={`row_${item.Achievement_id}`} index={index}>
                      {(provided: any, snapshot: any) => (
                        <div

                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <AchievementDetail
                            key={index}
                            {...item}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>}
          {message ? <p style={{ color: "red" }}>{message}</p> : <></>}
          {addNew ? <AddAchievement {...{ setAddNew: setAddNew }} /> : <></>}

          <Row style={{ position: 'relative' }}>
            <p
              className={styles['add-new']}
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              onClick={(e) => {
                setAddNew(true);
              }}
            >
              Add New (+)
            </p>
          </Row>
        </AchievementListContext.Provider>
      </UserAchievementsDataContext.Provider>
    </div>
  );
};

export default AchievementCard;
